import { Filter, MoreHorizCircle, Star, WarningTriangle } from "iconoir-react";
import { inject, observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import UnreadText from "../components/common/UnreadText";
import MainLayout from "../layouts/MainLayout";
import queryString from "query-string";
import {
    Drawer,
    Paper,
    SwipeableDrawer,
    Table,
    TableBody,
    TableCell,
    tableCellClasses,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
} from "@mui/material";
import { ASSIGNEE_TYPE, WORK_STATUS } from "../utils/constants";
import EmptyData from "../components/image/EmptyData";
import SkeletonTable from "../components/Skeleton/SkeletonTable";
import CheckLight from "../components/image/CheckLight";
import CheckSuccessIcon from "../components/image/CheckSuccessIcon";
import ImportantStar from "../components/image/ImportantStar";
import moment from "moment";
import { removeHtml } from "../utils/common";
import ContentModal from "../components/dialog/ContentModal";
import HandlerModal from "../components/dialog/HandlerModal";
import SearchAdvanceDrawer from "../modules/mission/SearchAdvanceDrawer";
import { EmptyText } from "../components/common/CellText";

const TRANG_THAI_WIDTH = 94;
const NHIEM_VU_WIDTH = 241;
const LANH_DAO_GIAO_VIEC_WIDTH = 180;
const THOI_GIAN_WIDTH = 230;

const date = new Date();
const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
const MissionPage = ({ taskStore }) => {
    const {
        getTaskList,
        taskList,
        getTaskLevelList,
        taskLevelList,
        getTagList,
        tagList,
    } = taskStore;
    const [isRefreshPage, setIsRefreshPage] = useState(true);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const location = useLocation();
    const queryStringParse = queryString.parse(location.search, {
        arrayFormat: "index",
    });
    const [openContent, setOpenContent] = useState(false);
    const [openLeader, setOpenLeader] = useState(false);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [taskSelect, setTaskSelect] = useState({});

    const [taskListView, setTaskListView] = useState([]);

    const [filter, setFilter] = useState({
        date_by: "DISPLAY_DATE",
        from_date: moment(firstDay).format("YYYY-MM-DD"),
        to_date: moment(lastDay).format("YYYY-MM-DD"),
        tag: null,
        tien_do: null,
        id_task_level: null,
    });

    const handelGetTaskList = async (params) => {
        try {
            setLoading(true);
            await getTaskList(params);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const params = {
            date_by: queryStringParse.date_by || filter.date_by,
            from_date: queryStringParse.from_date || filter.from_date,
            to_date: queryStringParse.to_date || filter.to_date,
            tien_do: queryStringParse.tien_do || filter.tien_do,
            id_task_level:
                queryStringParse.id_task_level || filter.id_task_level,
            tag: queryStringParse.tag || filter.tag,
            //     id_unit: null,
            //     id_user_unit: null,
            //     loai_nhiem_vu: null,
            //     assignee: null,
            //     date_by: "DISPLAY_DATE",
        };
        setFilter(params);
        (async () => {
            await Promise.all([
                getTaskLevelList(),
                handelGetTaskList(params),
                getTagList(),
            ]);
            setIsRefreshPage(false);
        })();
    }, []);
    useEffect(() => {
        if (isRefreshPage) return;
        const queryStringStringify = queryString.stringify(filter, {
            skipNull: true,
        });
        navigate({ pathname: "/mission", search: queryStringStringify });
        (async () => {
            try {
                await handelGetTaskList(filter);
            } catch (err) {
                console.log(err);
            }
        })();
    }, [filter]);
    useEffect(() => {
        const newTaskList = taskList.map((item) => item.content).flat();
        const groupByTaskCode = newTaskList.reduce((result, currentValue) => {
            (result[currentValue.task_code] =
                result[currentValue.task_code] || []).push(currentValue);
            return result;
        }, {});
        const unique = [
            ...new Map(
                newTaskList.map((item) => [item.task_code, item])
            ).values(),
        ];
        setTaskListView(
            unique.map((item) => ({
                ...item,
                leader: groupByTaskCode[item.task_code].map(
                    (sub) => sub.leader_name
                ),
                overdue:
                    item.ket_qua.phan_tram_hoan_thanh !== "100" &&
                    item.ngay_ket_thuc &&
                    moment(new Date()).isAfter(item.ngay_ket_thuc),
            }))
        );
    }, [taskList]);
    console.log("taskListView", { taskListView });

    function createData(status, noi_dung, leader, period, task_code) {
        return {
            status,
            noi_dung,
            leader,
            period,
            task_code,
        };
    }
    const formatData = (dataList) => {
        return dataList.map((record) =>
            createData(
                <div className="flex items-center gap-4 pl-4">
                    {" "}
                    <div>
                        {record?.ket_qua?.phan_tram_hoan_thanh === "0" ? (
                            <CheckLight />
                        ) : (
                            <CheckSuccessIcon />
                        )}
                    </div>{" "}
                    <div>
                        {record?.overdue && (
                            <WarningTriangle
                                color="#DB8300"
                                fill="#FFE5A1"
                                width={20}
                                height={20}
                            />
                        )}
                    </div>
                </div>,
                <div>
                    {record.noi_dung ? (
                        <UnreadText
                            text={removeHtml(record.noi_dung)}
                            width={NHIEM_VU_WIDTH}
                            icon={
                                <MoreHorizCircle
                                    className="text-primary"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setOpenContent(true);
                                        setTaskSelect(record);
                                    }}
                                />
                            }
                        />
                    ) : (
                        <EmptyText>Không có</EmptyText>
                    )}
                </div>,
                <UnreadText
                    text={record?.leader.join(", ")}
                    width={LANH_DAO_GIAO_VIEC_WIDTH}
                    icon={
                        <MoreHorizCircle
                            className="text-primary"
                            onClick={(e) => {
                                e.stopPropagation();
                                setOpenLeader(true);
                                setTaskSelect(record);
                            }}
                        />
                    }
                />,
                <div style={{}}>
                    {`${record.ngay_bat_dau
                        ? moment(record.ngay_bat_dau).format("DD/MM/YYYY")
                        : "Không rõ"
                        } 
              -
              ${record.ngay_ket_thuc
                            ? moment(record.ngay_ket_thuc).format("DD/MM/YYYY")
                            : "Không rõ"
                        }`}
                </div>,

                record?.task_code
            )
        );
    };
    const rows = formatData(taskListView);
    return (
        <MainLayout initialValue={4}>
            <div className="min-h-screen px-5">
                <div className="flex justify-between items-center mb-[16px]">
                    <div className="font-bold text-[28px] leading-[29px]  ">
                        Nhiệm vụ
                    </div>
                    <span
                        className="w-5 cursor-pointer"
                        onClick={() => {
                            setOpenDrawer(true);
                        }}
                    >
                        <Filter />
                    </span>
                </div>
                <div className="flex items-center gap-6">
                    <div className="flex items-center gap-2">
                        <CheckSuccessIcon />
                        <span className="font-bold text-[14px] leading-6 text-[#23374D]">
                            Hoàn thành:{" "}
                            {
                                taskListView?.filter(
                                    (item) =>
                                        item?.ket_qua?.phan_tram_hoan_thanh ===
                                        "100"
                                ).length
                            }
                        </span>
                    </div>
                    <div className="flex items-center gap-2">
                        {" "}
                        <CheckLight />
                        <span className="font-bold text-[14px] leading-6 text-[#23374D]">
                            Chưa hoàn thành:{" "}
                            {
                                taskListView?.filter(
                                    (item) =>
                                        item?.ket_qua?.phan_tram_hoan_thanh ===
                                        "0"
                                ).length
                            }
                        </span>
                    </div>
                </div>
                {loading ? (
                    <SkeletonTable />
                ) : taskList?.length > 0 ? (
                    <>
                        <section className="mt-5 overflow-x-auto hideScrollbar work-table">
                            <TableContainer
                                component={Paper}
                                className="w-[840px] "
                            >
                                <Table
                                    sx={{
                                        [`& .${tableCellClasses.root}`]: {
                                            borderBottom: "none",
                                        },
                                        fontSize: 14,
                                        lineHeight: 24,
                                        borderCollapse: "separate",
                                        borderSpacing: "0px 6px",
                                    }}
                                    aria-label="collapsible table"
                                >
                                    <TableHead className="bg-primary ">
                                        <TableRow>
                                            <TableCell
                                                width={TRANG_THAI_WIDTH}
                                                align="center"
                                                className="text-white font-bold w-[127px]"
                                            >
                                                Trạng thái
                                            </TableCell>
                                            <TableCell
                                                width={NHIEM_VU_WIDTH}
                                                className="font-bold text-white"
                                            >
                                                Nhiệm vụ
                                            </TableCell>
                                            <TableCell
                                                width={LANH_DAO_GIAO_VIEC_WIDTH}
                                                className="font-bold text-white"
                                            >
                                                Lãnh đạo giao việc
                                            </TableCell>
                                            <TableCell
                                                width={THOI_GIAN_WIDTH}
                                                className="font-bold text-white"
                                            >
                                                Thời gian
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {rows.map((row) => (
                                            <TableRow
                                                onClick={() => {
                                                    navigate(
                                                        `/mission/view/${row.task_code}`
                                                    );
                                                }}
                                                sx={{
                                                    "& > *": {
                                                        borderBottom: "unset",
                                                    },
                                                    // backgroundColor: "#F8F8F8",
                                                }}
                                            >
                                                <TableCell
                                                    component="td"
                                                    scope="row"
                                                >
                                                    {row.status}
                                                </TableCell>
                                                <TableCell>
                                                    {row.noi_dung}
                                                </TableCell>
                                                <TableCell>
                                                    {row.leader}
                                                </TableCell>
                                                <TableCell>
                                                    {row.period}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </section>{" "}
                    </>
                ) : (
                    <EmptyData />
                )}
            </div>
            <ContentModal
                open={openContent}
                handleClose={() => {
                    setOpenContent(false);
                }}
                content={taskSelect?.noi_dung}
                headerTitle="Nhiệm vụ"
            />
            <HandlerModal
                open={openLeader}
                handleClose={() => {
                    setOpenLeader(false);
                }}
                handler={taskSelect?.leader?.map((item) => ({
                    full_name: item,
                    assignee_type: ASSIGNEE_TYPE.GROUP,
                }))}
                headerTitle="Lãnh đạo giao việc"
            />

            <SearchAdvanceDrawer
                open={openDrawer}
                onClose={() => setOpenDrawer(false)}
                onOpen={() => setOpenDrawer(true)}
                filter={filter}
                setFilter={setFilter}
                taskLevelList={taskLevelList}
                tagList={tagList}
            />
        </MainLayout>
    );
};

export default inject("taskStore")(observer(MissionPage));
